import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiConstants } from "../constants/apiConstants";
import axiosApi from "../api/axiosAPI";



export const getProviderNotes = createAsyncThunk(
    "dialogApiService/getProviderNotes",
    async (formBody, { dispatch }) => {
        const resp = await axiosApi.post(apiConstants.dashboard.getProviderNotes, formBody);
        return resp.data;
    }
);
export const userSignUp = createAsyncThunk(
    "loginApi/signUp",
    async (formBody, { dispatch }) => {
        const params = {
            first_name: formBody.firstName,
            last_name: formBody.lastName,
            gender_id: formBody.gender,
            user_name: formBody.email,
            email_address: formBody.email,
            password: formBody.password,
            dob: formBody.dob,
            usertype_id: formBody.usertype_id,
        };
        console.log("sign up params", params)


        try {
            const resp = await axiosApi.post(apiConstants.login?.userSignup, params);
            const data = resp.data;
            console.log("signUp", resp);

            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);


export const createAllergies = createAsyncThunk(
    "dialogApiService/createAllergies",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.createAllergies, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setAllergies(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);
//call createAllergies in the component and pass the formBody as an argument
export const createUserMedicalHistory = createAsyncThunk(
    "dialogApiService/createUserMedicalHistory",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.createUserMedicalHistory, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            console.log('API Response history:', resp.data);
            dispatch(setUserMedicalHistory(resp.data));
            return resp.data;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    }
);
export const createUserAppointment = createAsyncThunk(
    "dialogApiService/createUserAppointment",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.createUserAppointment, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setUserAppointment(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);
// export const BulkMedicationCreate = createAsyncThunk(
//     'dialogApiService/BulkMedicationCreate',
//     async (formBody, { dispatch }) => {
//         try {

//             const formattedData = formBody.data.map(med => {

//                 return {
//                     MedicationName: med.MedicationName || '',
//                     Dose: med.Dose || '',
//                     MedicationRecurrence: med.MedicationRecurrence || '',
//                     MedicationStartedFrom: med.MedicationStartedFrom || new Date().toISOString().split('T')[0],
//                     MedicationComments: med.MedicationComments || '',
//                     Status: med.Status || 'Active',
//                     UserID: med.UserID,
//                     MedicationID: 0,
//                 };
//             });

//             const response = await axiosApi.post(
//                 apiConstants.dashboard.BulkMedicationCreate,
//                 formattedData,
//                 {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${formBody.token}`
//                     }
//                 }
//             );


//             // Even if the API returns false but status is 200, consider it a success
//             if (response.status === 200) {
//                 // Format the response data to match the expected structure
//                 const responseData = {
//                     Table: formattedData.map(med => ({
//                         medication_name: med.MedicationName,
//                         medication_dose: med.Dose,
//                         medication_recurrence: med.MedicationRecurrence,
//                         medication_started_from: med.MedicationStartedFrom,
//                         medication_comments: med.MedicationComments,
//                         medication_status: med.Status,
//                         user_id: med.UserID,
//                         medication_id: med.MedicationID
//                     }))
//                 };

//                 // Update the Redux store with the formatted data
//                 dispatch(setUserMedication({ data: responseData }));
//                 return { data: responseData };
//             }

//             throw new Error('Failed to create medication');
//         } catch (error) {
//             console.error("Error creating medication:", error);
//             throw error;
//         }
//     }
// );
//create medication

// export const BulkMedicationCreate = createAsyncThunk(
//     "dialogApiService/BulkMedicationCreate",
//     async (formBody, { dispatch }) => {
//         try {
//             // Construct the payload with all required fields
//             const payload = {
//                 MedicationName: formBody.MedicationName,
//                 MedicationRecurrence: formBody.MedicationRecurrence,
//                 MedicationStartedFrom: formBody.MedicationStartedFrom,
//                 UserID: formBody.UserID,
//                 MedicationID: formBody.MedicationID,
//                 MedicationComments: formBody.MedicationComments,
//                 Status: formBody.Status,
//                 Dose: formBody.Dose
//             };
//             console.log(payload, "payload")
//             const resp = await axiosApi.post(apiConstants.dashboard.BulkMedicationCreate, payload, {
//                 headers: {
//                     Authorization: `Bearer ${formBody.token}`,
//                     'Content-Type': 'application/json'
//                 },
//             });
//             console.log(resp.data, "resp.data")
//             console.log(resp.data.Table, "resp.data.Table")
//             return resp.data.Table;
//         } catch (error) {
//             console.error("Error creating medication:", error);
//             throw error;
//         }
//     }
// );
export const BulkMedicationCreate = createAsyncThunk(
    "dashboard/BulkMedicationCreate",
    async ({ medications, token }) => {
        // medications: array of medication objects
        const params = medications; 
        const resp = await axiosApi.post(apiConstants.dashboard.BulkMedicationCreate, params, {
            headers: { Authorization: `Bearer ${token}` }
        }); 
        // Just return the boolean (true/false) as the API returns
        return resp.data;
    }
);

export const BulkMedicationDelete = createAsyncThunk(
    "dashboard/BulkMedicationDelete",
    async ({ UserID, MedicationID, token }) => {
        const params = { UserID, MedicationID };
        console.log(params, "params");
        const resp = await axiosApi.post(apiConstants.dashboard.BulkMedicationDelete, params, {
            headers: { Authorization: `Bearer ${token}` }
        });
        console.log(resp.data, "resp.data");
        return resp.data;
    }
);

//Create Vaccination
export const createVaccination = createAsyncThunk(
    "dialogApiService/createVaccination",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.createVaccinations, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setVaccination(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);



//Create Provider Notes
export const createProviderNotes = createAsyncThunk(
    "dialogApiService/createProviderNotes",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.createProviderNotes, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setProviderNotes(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);
//Create Vital Signs
export const createVitalSigns = createAsyncThunk(
    "dialogApiService/createVitalSigns",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.createVitalSigns, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setVitalSigns(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);
// Add Vitals

export const VitalsSave = createAsyncThunk(
    "dialogApiService/VitalsSave",
    async (formBody, { dispatch }) => {
        try {
            // Split blood pressure into systolic and diastolic
            // const bp = formBody.BloodPressure_Systolic;
            // const [systolic, diastolic] = bp ? bp.split('/') : ['', ''];

            const payload = {
                WaistSize: formBody.WaistSize || '',
                HeartRate: formBody.HeartRate,
                BloodPressure_Systolic: formBody.BloodPressure_Systolic,
                BloodPressure_Diastolic: formBody.BloodPressure_Diastolic,
                BloodSugar: formBody.BloodSugar || '',
                Weight: formBody.Weight || '',
                VitalID: formBody.VitalID || '',
                LastUpdated: formBody.LastUpdated,
                LoginUserID: formBody.LoginUserID,
                token: formBody.token
            }; 
            const resp = await axiosApi.post(apiConstants.dashboard.VitalsSave, payload, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                    'Content-Type': 'application/json'
                },
            }); 
            console.log(resp.data,"resp.data");
            // Handle 204 No Content response
            if (resp.status === 204) {
                return {
                    status: 'success',
                    message: 'Vitals saved successfully',
                    Table: [], // Empty table for consistency
                    Table1: []
                };
            }

            // If we get a response with data, use it
            if (resp.data) {
                dispatch(setVitalSigns(resp.data));
                return {
                    status: 'success',
                    message: 'Vitals saved successfully',
                    Table: resp.data.Table || [],
                    Table1: resp.data.Table1 || []
                };
            }

            // If no response data but status is 200, still consider it success
            if (resp.status === 200) {
                return {
                    status: 'success',
                    message: 'Vitals saved successfully',
                    Table: [],
                    Table1: []
                };
            } 
            // If we get here, something unexpected happened
            throw new Error('Unexpected response');
        } catch (error) {
            console.error('Error in createVitals:', error);
            if (error.response) {
                console.error('Error Response:', error.response.data);
                console.error('Error Status:', error.response.status);
                throw error;
            } else if (error.request) {
                console.error('No response received:', error.request);
                throw new Error('No response from server');
            } else {
                console.error('Error details:', error.message);
                throw error;
            }
        }
    }
);

export const MetabolicsSave = createAsyncThunk(
    "dialogApiService/MetabolicsSave",
    async (formBody, { dispatch }) => {
        try {
            const payload = {
                WaistSize: formBody.WaistSize || '',
                HeartRate: formBody.HeartRate,
                BloodPressure_Systolic: formBody.BloodPressure_Systolic,
                BloodPressure_Diastolic: formBody.BloodPressure_Diastolic,
                BloodSugar: formBody.BloodSugar || '',
                Weight: formBody.Weight || '',
                VitalID: formBody.VitalID || '',
                LastUpdated: formBody.LastUpdated,
                LoginUserID: formBody.LoginUserID,
                token: formBody.token
            };
            const resp = await axiosApi.post(apiConstants.dashboard.MetabolicsSave, payload, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                    'Content-Type': 'application/json'
                },
            });

            if (resp.status === 204) {
                return {
                    status: 'success',
                    message: 'Metabolics saved successfully',
                    Table: [],
                    Table1: []
                };
            }

            if (resp.data) {
                dispatch(setVitalSigns(resp.data));
                return {
                    status: 'success',
                    message: 'Metabolics saved successfully',
                    Table: resp.data.Table || [],
                    Table1: resp.data.Table1 || []
                };
            }

            if (resp.status === 200) {
                return {
                    status: 'success',
                    message: 'Metabolics saved successfully',
                    Table: [],
                    Table1: []
                };
            }

            throw new Error('Unexpected response');
        } catch (error) {
            console.error('Error in MetabolicsSave:', error);
            if (error.response) {
                console.error('Error Response:', error.response.data);
                console.error('Error Status:', error.response.status);
                throw error;
            } else if (error.request) {
                console.error('No response received:', error.request);
                throw new Error('No response from server');
            } else {
                console.error('Error details:', error.message);
                throw error;
            }
        }
    }
);

//Delete Allergies
export const deleteAllergies = createAsyncThunk(
    "dialogApiService/deleteAllergies",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.deleteAllergies, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setAllergies(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);
//Delete Appointment
export const deleteAppointment = createAsyncThunk(
    "dialogApiService/deleteAppointment",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.deleteAppointment, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setUserAppointment(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);
//Delete Vaccination
export const deleteVaccination = createAsyncThunk(
    "dialogApiService/deleteVaccination",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.deleteVaccination, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setVaccination(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);
//Delete Provider Notes
export const deleteProviderNotes = createAsyncThunk(
    "dialogApiService/deleteProviderNotes",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.deleteProviderNotes, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setProviderNotes(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);

export const deleteUserAppointmentDetails = createAsyncThunk(
    "dialogApiService/UsersAppointmentDelete",
    async (formBody, { dispatch }) => {
        try {
            console.log('Making API call to delete vaccination', {
                endpoint: apiConstants.dashboard.deleteUserAppointmentDetails,
                payload: formBody
            });
            console.log('Making API call to delete vaccination', formBody)

            const resp = await axiosApi.post(
                apiConstants.dashboard.deleteUserAppointmentDetails,
                formBody,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );

            console.log('Delete appointments API response:', resp.data);
            dispatch(setVaccination(resp.data));
            return resp.data;
        } catch (error) {
            console.error('Delete appointments API error:', {
                message: error.message,
                response: error.response?.data,
                config: error.config
            });
            throw error;
        }
    }
);
//to save th

export const deleteVitalRecord = createAsyncThunk(
    "dashBoardApi/deleteVitalRecord",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.deleteVitalRecord, {
                VitalID: formBody.VitalID,
                UserID: formBody.LoginUserID
            }, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                console.log("Request:", error.request);
            } else {
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

export const deleteMetabolicsRecord = createAsyncThunk(
    "dashBoardApi/deleteMetabolicsRecord",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.deleteMetabolicsRecord, {
                VitalID: formBody.VitalID,
                UserID: formBody.LoginUserID
            }, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                console.log("Request:", error.request);
            } else {
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);
export const internalSharedReportRevoke = createAsyncThunk(
    "dialogApiService/internalSharedReportRevoke",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(
                apiConstants.reports.internalSharedReportRevoke,
                formBody,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            console.log(resp.data, "resp.data123");
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);
export const dialogApiServiceSlice = createSlice({
    name: "dialogApiService",
    initialState: {
        dialogData: null,
    },
    reducers: {
        setAllergies: (state, action) => {
            state.allergiesData = action.payload;
        },
        setUserAppointment: (state, action) => {
            state.userAppointmentData = action.payload;
        },
        setUserMedication: (state, action) => {
            state.userMedicationData = action.payload;
        },
        setVaccination: (state, action) => {
            state.vaccinationData = action.payload;
        },
        setMedicalHistory: (state, action) => {
            state.medicalHistoryData = action.payload;
        },
        setProviderNotes: (state, action) => {
            state.providerNotesData = action.payload;
        },
        setVitalSigns: (state, action) => {
            state.vitalSignsData = action.payload;
        },
        setUserMedicalHistory: (state, action) => {
            state.userMedicalHistoryData = action.payload;
        },
        setUserAppointmentDetails: (state, action) => {
            state.userAppointmentDetailsData = action.payload;
        },
        setUploadReportFromClaud: (state, action) => {
            state.uploadReportFromClaudData = action.payload;
        },

    },

});


export const {
    setAllergies,
    setUserAppointment,
    setUserMedication,
    setVaccination,
    setMedicalHistory,
    setProviderNotes,
    setVitalSigns,
    setUserMedicalHistory,
    setUserAppointmentDetails,
    setUploadReportFromClaud,

} = dialogApiServiceSlice.actions;

export default dialogApiServiceSlice.reducer;
